import { get } from 'lodash';
import { UNKNOWN_PROFESSIONAL_REFERENCE } from '../../../../shared/ramq/requiredDetails/professionalReferenceConstants';
import { SingleLineField } from '../../../components/Form/Fields';

const summaryRender = (code) => [
  {
    name: 'Prof.',
    value: `${get(code[UNKNOWN_PROFESSIONAL_REFERENCE], 'firstName', '-')} ${get(
      code[UNKNOWN_PROFESSIONAL_REFERENCE],
      'lastName',
      '-'
    )}`
  }
];

const associatedFields = [
  {
    label: 'Nom de la sage-femme',
    getName: (index) => `codes[${index}].${UNKNOWN_PROFESSIONAL_REFERENCE}.lastName`,
    type: SingleLineField
  },
  {
    label: 'Prénom de la sage-femme',
    getName: (index) => `codes[${index}].${UNKNOWN_PROFESSIONAL_REFERENCE}.firstName`,
    type: SingleLineField
  }
];

const quebecMidwife = { associatedFields, summaryRender };

export default quebecMidwife;
